// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1j-7";
export var adjustableWidthBorderHeld = "_1j-8";
export var arrow = "_1j-3";
export var arrowButton = "_1j-4";
export var headerCell = "_1j-0";
export var help = "_1j-2";
export var icon = "_1j-1";
export var iconWrapper = "_1j-6";
export var noBorder = "_1j-b";
export var nonAdjustableWidthBorder = "_1j-9";
export var nonAdjustableWidthBorderHeld = "_1j-a";
export var textButton = "_1j-5";